import { createSelector } from 'reselect';

import { StateType } from '../index';
import Immutable from 'immutable';

export const alphasFetchingPropertiesSelector = (state: StateType) => state.getIn(['alphas', 'fetchingProperties']);
export const alphasFetchingSubmitAlphaSelector = (state: StateType) => state.getIn(['alphas', 'fetchingSubmitAlpha']);
export const alphaDetailSelector = (state: StateType) => state.getIn(['alphas', 'alphaDetail']);
export const alphaDetailIdSelector = (state: StateType) => state.getIn(['alphas', 'alphaDetail', 'id']) as string | null;
export const alphaDetailStatusSelector = (state: StateType) => state.getIn(['alphas', 'alphaDetail', 'status']);
const submittedStatuses = new Set(['ACTIVE', 'DECOMMISSIONED']);
export const getIsAlphaSubmittedSelector = (state: StateType) => submittedStatuses.has(alphaDetailStatusSelector(state) as string);
export const alphaShowDetailSelector = (state: StateType) => state.getIn(['alphas', 'showDetail']);
export const alphaPathSelector = (state: StateType) => state.getIn(['alphas', 'alphasPath']);
export const alphaSelfCorrelationDataSelector = (state: StateType) => state.getIn(['alphas', 'selfCorrelationData']);
export const alphasFetchingDataSelector = (state: StateType) => state.getIn(['alphas', 'fetchingData']);
export const alphasOptionsSelector = (state: StateType) => state.getIn(['alphas', 'options']);
export const alphasLoadedOptionsSelector = (state: StateType) => state.getIn(['alphas', 'loadedOptions']) as boolean;
export const alphasTypeSelector = (state: StateType) => state.getIn(['alphas', 'type']) as string;
export const alphasHasComeFromAlphaPageSelector = (state: StateType) => state.getIn(['alphas', 'hasComeFromAlphaPage']);
export const alphasOptionsSettingsChildrenSelector = (state: StateType) => state.getIn(['alphas', 'options', 'settings', 'children']);
export const alphasOptionsGradeChoicesSelector = (state: StateType) => state.getIn(['alphas', 'options', 'grade', 'choices']);
export const alphasOptionsOsmosisPointsSelector = (state: StateType) =>
  state.getIn(['alphas', 'options', 'osmosisPoints']) as Immutable.Map<string, any> | undefined;

export const alphaDetailIsTestPeriodControlShown = (state: StateType) =>
  alphaDetailStatusSelector(state) === 'UNSUBMITTED' && (!!state.getIn(['alphas', 'alphaDetail', 'test', 'startDate']) as boolean);

export const alphaDetailIsTestPeriodShown = (state: StateType) =>
  alphaDetailIsTestPeriodControlShown(state) && (state.getIn(['alphas', 'alphaDetail', 'isTestPeriodShown']) as boolean);
export const alphasFetchingCheckSelector = (state: StateType) => state.getIn(['alphas', 'fetchingCheck']);
export const alphaMyAlphasResultsSelector = (state: StateType) => state.getIn(['alphas', 'myAlphas', 'results']);
export const alphaMyAlphasCountSelector = (state: StateType) => state.getIn(['alphas', 'myAlphas', 'count']);
export const alphaMyAlphasMessageSelector = (state: StateType) => state.getIn(['alphas', 'myAlphas', 'message']);
export const alphaMyAlphasSelector = (state: StateType) => state.getIn(['alphas', 'myAlphas']);

export const alphaSelectedColumnsSelector = (state: StateType) => state.getIn(['alphas', 'selectedColumns']);

export const alphaSuperAlphaPropertiesNameSelector = (state: StateType) => state.getIn(['alphas', 'superAlphaProperties', 'name']);
export const alphasTeamOwnerSelector = (state: StateType) => state.getIn(['alphas', 'alphaDetail', 'author']);

export const alphaIsSuperSelector = (state: StateType) => state.getIn(['alphas', 'type']) === 'super';
export const pathHasSuperSelectionSelector = createSelector(
  alphaPathSelector,
  // @ts-ignore
  path => path && path.includes('super-selection')
);

export const currentAlphaRegionSelector = (state: StateType) => state.getIn(['alphas', 'alphaDetail', 'settings', 'region']);

export const currentAlphaInstrumentTypeSelector = (state: StateType) =>
  state.getIn(['alphas', 'alphaDetail', 'settings', 'instrumentType']) || 'EQUITY';

export const alphasNumOfUnsubmittedSelector = (state: StateType) => state.getIn(['alphas', 'numOfUnsubmitted']) as number;
export const alphasNumOfActiveSelector = (state: StateType) => state.getIn(['alphas', 'numOfActive']) as number;
export const alphasNumOfDecommissionedSelector = (state: StateType) => state.getIn(['alphas', 'numOfDecommissioned']) as number;
export const alphasFetchNumSelector = (state: StateType) => state.getIn(['alphas', 'fetchNum']) as boolean;

export const alphaDetailStatusReturnStringSelector = createSelector(alphaDetailStatusSelector, status => (status ? status : ''));

export const showAlphaDetailIFHasComefromAlphaPage = createSelector(
  alphasHasComeFromAlphaPageSelector,
  alphaDetailSelector,
  (comesFromAlphaPage, alphaDetail) => (comesFromAlphaPage ? null : alphaDetail)
);
